var url = process.env.API_URL + process.env.API_VERSION;
import axios from 'axios';

const state  = {
	list_counselors: [],
  list_service: [],
  appointment_info: {},  
}

const mutations = {
	SET_LIST_COUNSELORS(state, data){
    state.list_counselors = data.counselors
  },
  SET_LIST_SERVICES(state, list_services){
    state.list_services = list_services;
  },
  set_appointment_info(state, appointment){
    state.appointment_info = appointment
  },  
}

const actions = {
  load_list_counselors({commit}) {    
    axios.get(url + "/users/get_list_counselors?per_page=1000",
      {
      })
      .then((response) =>{          
        commit('SET_LIST_COUNSELORS', response.data.extra)
      })
  },
  load_list_services({commit}) {
    axios.get(url + '/services')
      .then((response) =>{
        commit('SET_LIST_SERVICES', response.data.extra.services)
    })
  },
  load_appointment_info({commit}, id){    
    axios.get(url + '/appointment/get_appointment?id=' + id)
    .then((response) => {
      commit('set_appointment_info', response.data.extra.appointment)      
    })
    .catch((errors) => {      
      alert('Không thể load được lịch hẹn')
    })    
  }
}
const getters = {
  get_list_counselor: (state) => {
    return state.list_counselors}
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vuex_booking_form.js